import React from 'react'
import { Checkbox } from '@rmwc/checkbox';
import EditPriceItem from '../../EditPriceItem/EditPriceItem';
import CurrencyFormat from 'react-currency-format';
import { const_var ,params} from '../../../redux/reducers/reducer';


export default function WrapAroundConnectFee({porch_connection_fee ,name}) {
    // console.log( porch_connection_fee, name,const_var.post_data?.building[porch_connection_fee] );
  return (
    <div className='control-field-bar'>
        <div className='control-field'>                  
            <Checkbox 
            ripple="RipplePropF"
            label={name}
            checked="true" 
        />
        </div>
        <div className='control-field-action'>
        {((const_var.post_data.building!=undefined && const_var.loginSession == true))?
            <aside className="price-box">
                <EditPriceItem jsonObj={const_var.post_data.building[porch_connection_fee]} jsonObjKey={porch_connection_fee}/>
            </aside>
            :
            <div className='price-box-type-2' >
                {const_var.hide_price_calculation != 1 && const_var.loginSession == false && (const_var.post_data.building!=undefined && const_var.post_data.building[porch_connection_fee]!=undefined) && const_var.post_data.building[porch_connection_fee] !== 0 && 
                    <CurrencyFormat value = {const_var.post_data.building[porch_connection_fee]} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                }
            </div>
        }
        </div>
    </div>
  )
}
